import { useEffect } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { useI18n } from "./i18n.jsx";

const BRAND = "NLP Magick";

// Route → i18n key for the suffix. Order matters: most-specific first.
const ROUTE_TITLE_MAP = [
  { pattern: "/", key: "title.landing" },
  { pattern: "/login", key: "title.login" },
  { pattern: "/register", key: "title.register" },
  { pattern: "/diary", key: "title.diary" },
  { pattern: "/rituals", key: "title.rituals" },
  { pattern: "/rituals/:slug", key: "title.ritual_detail" },
  { pattern: "/lectures", key: "title.lectures" },
  { pattern: "/lectures/:id", key: "title.lecture_detail" },
  { pattern: "/library", key: "title.library" },
  { pattern: "/pantheon", key: "title.pantheon" },
  { pattern: "/pantheon/new", key: "title.pantheon_new" },
  { pattern: "/pantheon/:id", key: "title.pantheon_detail" },
  { pattern: "/pantheon/:id/edit", key: "title.pantheon_edit" },
  { pattern: "/tarot/personality-card", key: "title.tarot_personality" },
  { pattern: "/tarot/celtic-cross", key: "title.tarot_celtic" },
  { pattern: "/tarot/ultrasecret", key: "title.tarot_ultrasecret" },
  { pattern: "/podcasts", key: "title.podcasts" },
  { pattern: "/admin", key: "title.admin" },
  { pattern: "/account", key: "title.account" },
  { pattern: "/privacy", key: "title.privacy" },
  { pattern: "/terms", key: "title.terms" },
];

function pickKeyForPath(pathname) {
  // Try exact-then-pattern matches, prefer longer (more specific) routes.
  const candidates = ROUTE_TITLE_MAP
    .filter((r) => matchPath({ path: r.pattern, end: true }, pathname))
    .sort((a, b) => b.pattern.length - a.pattern.length);
  return candidates[0]?.key || null;
}

export function PageTitle() {
  const { pathname } = useLocation();
  const { t, lang } = useI18n();
  useEffect(() => {
    const key = pickKeyForPath(pathname);
    const suffix = key ? t(key) : "";
    document.title = suffix ? `${BRAND} — ${suffix}` : BRAND;
    document.documentElement.lang = lang;
  }, [pathname, t, lang]);
  return null;
}
